/**
 * Canonical contact + social links. Single source of truth — import from here
 * instead of hardcoding emails/URLs in components (they had drifted, e.g. the
 * email was written 4 different ways across the site).
 */

// Real inbox. hey@arne.ai forwards here; don't reintroduce hello@/noori.me.
export const CONTACT_EMAIL = 'arne@arne.ai'

export const SOCIAL_URLS = {
  twitter: 'https://x.com/arnenoori',
  github: 'https://github.com/arnenoori',
  linkedin: 'https://linkedin.com/in/arnenoori',
  instagram: 'https://instagram.com/arnenoori',
  website: 'https://arne.ai',
} as const

export type SocialPlatform = keyof typeof SOCIAL_URLS

/** `@handle` form of the X/Twitter URL, for `twitter:creator` meta tags. */
export const TWITTER_HANDLE = `@${SOCIAL_URLS.twitter.split('/').pop()}`
